module.exports = __webpack_public_path__ + "static/img/7.fcd82dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/eng/7.png
// module id = 6w4l
// module chunks = 0